import { ManagementApi } from "./api/management/index";
import {
  ActivityHistoryModel,
  ActivityNextModel,
  CustomerModel,
  FilterModel,
  H2HModel,
  MapCustomerModel,
  SaleManageerBySurveyHistoryModel,
  SaleManagerByCustomerModel,
  CustomerCreditModel,
} from "@/models/classes/management";

import { plainToClassFromExist } from "class-transformer";
import { ResponsesModel } from "@/models/classes/responses";
import { ActivityItemModel } from "@/models/classes/overview/activity_items";
import { ResponseModel } from "@/models/classes/response";
import axios from "axios";
import qs from "qs";

const api = new ManagementApi();

export class ManagementService {
  fetchFilterManagementView = async (params: any = {}) => {
    const resData = await api.getFilterManagementView(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<FilterModel>(FilterModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchCustomerManagementView = async (params: any = {}, signal?: AbortSignal) => {
    const resData = await api.getCustomerManagementView(params, signal);
    const resModel = plainToClassFromExist(
      new ResponsesModel<MapCustomerModel>(MapCustomerModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchCustomerCredit = async (params: any = {}) => {
    const resData = await api.getCustomerCredit(params);
    const resModel = plainToClassFromExist(
      new ResponseModel<CustomerCreditModel>(CustomerCreditModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };



  fetchActivityHistory = async (params: any = {}) => {
    const resData = await api.getActivityHistory(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<ActivityHistoryModel>(ActivityHistoryModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchActivityNext = async (params: any = {}) => {
    const resData = await api.getActivityNext(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<ActivityNextModel>(ActivityNextModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchEActivity = async (params: any = {}) => {
    const resData = await api.getEActivity(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<ActivityItemModel>(ActivityItemModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchGetCustomer = async (params: any = {}) => {
    const resData = await api.getDetailCustomer(params);
    const resModel = plainToClassFromExist(
      new ResponseModel<CustomerModel>(CustomerModel),
      resData,
    );

    if (
      resModel.status == 200 &&
      typeof resModel.data == "object" &&
      resModel.data !== null
    ) {
      resModel.data.id = params.customerId;
      return {
        data: resModel.data,
        total: resModel.total,
      };
    }
    return undefined;
  };

  fetchGetH2H = async (params: any = {}) => {
    const resData = await api.getDetailH2H(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<H2HModel>(H2HModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      let legend = new Array();
      if (resModel.data) {
        resModel.data?.map((item: H2HModel) => {
          legend.push({
            name: item.companyBrand,
            color: item.companyColorCode,
          });
          legend.push({
            name: item.otherBrand,
            color: item.otherColorCode,
          });
        });
      }

      return {
        data: resModel.data,
        total: resModel.total,
        legend: legend,
      };
    }
    return undefined;
  };

  fetchViewSaleManagerByCustomer = async (params: any = {}) => {
    const resData = await api.getViewSaleManagerByCustomer(params);
    const resModel = plainToClassFromExist(
      new ResponseModel<SaleManagerByCustomerModel>(SaleManagerByCustomerModel),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data };
    }
    return undefined;
  };

  fetchViewSaleManagerBySurveyHistory = async (params: any = {}) => {
    const resData = await api.getViewSaleManagerBySurveyHistory(params);
    const resModel = plainToClassFromExist(
      new ResponsesModel<SaleManageerBySurveyHistoryModel>(
        SaleManageerBySurveyHistoryModel,
      ),
      resData,
    );

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { data: resModel.data };
    }
    return undefined;
  };

  //MARK: tracking ข้อมูลการขาย
  fetchTrackingSummary = async (
    params: { customerId: string; brands?: string } = {
      customerId: "",
      brands: "",
    },
  ) => {
    if (!params.customerId) throw new Error("customerId is required");
    let path = `/api/Customer/${params.customerId}/Tracking/Summary`;
    if (params.brands) {
      path += `?brands=${params.brands}`;
    }
    const resp = await axios.get(path);
    return resp.data;
  };

  fetchTrackingInfo = async (
    params: { brands?: string; customerId: string } = {
      brands: "",
      customerId: "",
    },
  ) => {
    if (!params.customerId) throw new Error("customerId is required");
    let path = `/api/Customer/${params.customerId}/Tracking/Infos`;
    if (params.brands) {
      path += `?brands=${params.brands}`;
    }
    const resp = await axios.get(path);
    return resp.data;
  };

  fetchTrackingDaily = async (
    params: { customerId: string; brandIds?: number[]; skus?: string[] } = {
      customerId: "",
    },
  ) => {
    // Load for API (commented out as per requirements)
    if (!params.customerId) throw new Error("customerId is required");
    let path = `/api/Customer/${params.customerId}/Tracking/Daily`;
    const queryParams = new URLSearchParams();
    if (params.brandIds?.length) {
      params.brandIds.forEach((id) =>
        queryParams.append("brandIds", id.toString()),
      );
    }
    if (params.skus?.length) {
      params.skus.forEach((sku) => queryParams.append("skus", sku));
    }
    const queryString = queryParams.toString();
    if (queryString) {
      path += `?${queryString}`;
    }

    const resp = await axios.get(path);
    return resp.data;
  };

  fetchTrackingBrand = async (
    params: {
      customerid: string;
      searchText?: string;
      limit?: number;
      offset?: number;
    } = { customerid: "" },
  ) => {
    // Load for API (commented out as per requirements)
    let path = `/api/Customer/${params.customerid}/Tracking/Brands`;
    const queryParams = new URLSearchParams();
    if (params.searchText) queryParams.append("searchText", params.searchText);
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.offset) {
      queryParams.append("offset", params.offset.toString());
    } else {
      queryParams.append("offset", "0".toString());
    }
    const queryString = queryParams.toString();
    if (queryString) path += `?${queryString}`;
    const resp = await axios.get(path);
    return resp.data;

    /*
    try {
    } catch (error) {
      // Mock implementation
      console.log("fetchTrackingBrand", params);
      const all = Array.from({ length: 500 }, (_, i) => ({ id: i + 1, name: `Brand ${i + 1}` }));
      const filtered = params.searchText ? all.filter((b) => b.name.toLowerCase().includes(params.searchText?.toLowerCase() || "")) : all;
      const slice = filtered.slice(params.offset || 0, (params.offset || 0) + (params.limit || 30));

      return { data: slice, xTotalCount: 82 };
    }
    */
  };

  fetchTrackingSku = async (
    params: {
      customerid: string;
      brandIds?: number[];
      searchText?: string;
      limit?: number;
      offset?: number;
    } = { customerid: "" },
  ) => {
    // Load for API (commented out as per requirements)
    let path = `/api/Customer/${params.customerid}/Tracking/Skus`;
    const queryParams = new URLSearchParams();
    if (params.brandIds?.length) {
      params.brandIds.forEach((id) =>
        queryParams.append("brandIds", id.toString()),
      );
    }
    if (params.searchText) queryParams.append("searchText", params.searchText);
    if (params.limit) queryParams.append("limit", params.limit.toString());
    if (params.offset) {
      queryParams.append("offset", params.offset.toString());
    } else {
      queryParams.append("offset", "0");
    }
    const queryString = queryParams.toString();
    if (queryString) path += `?${queryString}`;
    const resp = await axios.get(path);
    return resp.data;
    /*
    try{
    } catch (error) {
      // Mock implementation
      console.log("fetchTrackingSku", params);
      const base = params.brandIds?.length ? params.brandIds : [1, 2, 3];
      const all = base.flatMap((bid) =>
        Array.from({ length: 200 }, (_, i) => ({
          id: bid * 100000 + i + 1,
          name: `SKU ${i + 1} of Brand ${bid}`,
          code: `B${bid}-S${(i + 1).toString().padStart(3, "0")}`,
        }))
      );
      const filtered = params.searchText ? all.filter((s) => s.name.toLowerCase().includes(params.searchText?.toLowerCase() || "") || s.code.toLowerCase().includes(params.searchText?.toLowerCase() || "")) : all;
      const slice = filtered.slice(params.offset || 0, (params.offset || 0) + (params.limit || 30));

      return { data: slice, xTotalCount: 93 };
    }
    */
  };
}
